var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 128,
    viewBox: "0 0 40 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddii_1_4377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3681 118.437C28.5163 116.517 29.6438 114.336 30.6424 111.892C33.3004 105.386 34.0012 99.597 34.1523 95.713L34.1523 31.953C34.0012 28.0689 33.3004 22.2779 30.6424 15.7744C29.6438 13.3317 28.5178 11.1489 27.3681 9.22937C25.1145 5.46435 19.6993 4.88165 16.6131 8.06216C14.7877 9.94377 12.9076 12.2583 11.2274 15.0654C7.06414 22.0218 6.20184 28.5379 6.00034 31.953L6.00034 95.713C6.20184 99.128 7.06265 105.646 11.2274 112.601C12.9076 115.406 14.7877 117.722 16.6131 119.604C19.6993 122.784 25.1145 122.203 27.3681 118.437ZM11.1919 88.1306C12.0675 76.343 12.5476 76.417 12.5209 63.6553C12.4942 51.6458 12.0201 50.1034 11.1919 38.9617C10.1814 34.6915 15.4382 31.3811 20.0771 31.3811C24.716 31.3811 29.9727 34.6915 28.9623 38.9617C28.1326 50.134 27.657 51.709 27.6333 63.7545C27.6081 76.482 28.0881 76.3737 28.9623 88.1306C29.9727 92.4008 24.716 95.7112 20.0771 95.7112C15.4382 95.7112 10.1814 92.4008 11.1919 88.1306Z",
    fill: "#FAF7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddii_1_4377",
    x: 0.540218,
    y: 0.540218,
    width: 39.0719,
    height: 126.586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.81993,
    dy: -1.81993
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.81993
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_4377"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.81993,
    dy: 1.81993
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.81993
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1_4377",
    result: "effect2_dropShadow_1_4377"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1_4377",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.81993,
    dy: -1.81993
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.909964
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_1_4377"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.81993,
    dy: 1.81993
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.909964
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_1_4377",
    result: "effect4_innerShadow_1_4377"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.08a9c3d41cc8ca9e2f99d14eaa04c1e1.svg";
export { ForwardRef as ReactComponent };